<template>
    <div class="arvore-de-influencia" @mousedown="onGlobalClick">
        <div v-if="areas.length === 0" class="no-config">
            <h1 class="clockText">{{ $t('nao-ha-dados-encontrados') }}</h1>
            <img src="../../assets/Monitoramento.png" class="iconPermission" :alt="$t('nao-ha-dados-encontrados')"
                :title="$t('nao-ha-dados-encontrados')" />
        </div>

        <div v-if="isLoading" class="loading-overlay">
            <img class="loading-over" src="../../assets/loading2.gif" />
        </div>

        <div v-else>
            <div class="tabs">
                <div class="tabs-header">
                    <ul class="tab-list">
                        <li v-for="(area, index) in areas" :key="area.id" :class="{ active: area.id === activeTab }"
                            class="tab-item-sec" @click="activeCurrentArea(area)">
                            <span v-if="!area.editing" class="tab-item-title" :title="area.name">
                                {{ truncateText(area.name, 35) }}
                            </span>
                            <input v-else v-model="area.name" class="tab-item-input" maxlength="50" @click.stop
                                @keyup.enter="toggleEditArea(area)" />
                            <button v-if="isEditMode" class="btn-icon" @click.stop="toggleEditArea(area)"
                                :title="area.editing ? 'Salvar Nome' : 'Editar Área'">
                                <img v-if="!area.editing" class="action-btn img-btn-small"
                                    src="../../assets/EDIT-PENCIL.svg" />
                                <img v-else class="action-btn img-btn-small ml-2" src="../../assets/OK-SIGNAL.svg" />
                            </button>
                            <button v-if="isEditMode" class="btn-icon" @click.stop="showConfirmDeleteAreaModal(index)"
                                title="Excluir Área">
                                <img class="action-btn img-btn-small trash-img" src="../../assets/excluir.png" />
                            </button>
                        </li>
                        <li :class="!isEditMode ? 'disableBtn' : 'tab-item tab-add'">
                            <button class="btn-add-area" @click.stop="showAddAreaModal" title="Adicionar Nova Área">
                                <img class="action-btn img-btn" src="../../assets/add.png" />
                            </button>
                        </li>
                    </ul>
                    <button v-if="!isEditMode" class="btn-add-area" @click.stop="openRotationConfigModal"
                        title="Configurar Rotação de Áreas">
                        <img class="action-btn btn-rotation-config" src="../../assets/configurar.png"
                            v-if="user.Permissions.editargestaoindicadores && user.Permissions.editargestaoindicadores.allowed && user.Permissions.editargestaoindicadores.permission" />
                    </button>
                    <button v-if="!isEditMode" class="btn-update-indicators" @click.stop="updateIndicatorValues(true)"
                        title="Atualizar valores dos indicadores"> <img class="action-btn img-btn"
                            src="../../assets/atualizar.png" alt="Atualizar" />
                    </button>
                    <div class="btn-group-config">
                        <button class="btn-edit-mode"
                            :title="isEditMode ? 'Mudar para Modo Visualização' : 'Mudar para Modo Edição'">
                            <img @click="sendConfiguration"
                                v-if="isEditMode && user.Permissions.editargestaoindicadores && user.Permissions.editargestaoindicadores.allowed && user.Permissions.editargestaoindicadores.permission"
                                class="action-btn img-btn" src="../../assets/salvar.png" />
                            <img @click="isEditMode = !isEditMode"
                                v-if="!isEditMode && user.Permissions.editargestaoindicadores && user.Permissions.editargestaoindicadores.allowed && user.Permissions.editargestaoindicadores.permission"
                                class="action-btn img-btn-refresh" src="../../assets/EDIT-PENCIL.svg" />
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="activeArea" class="tab-content">
                <div v-for="(product, prodIndex) in activeArea.produtos" :key="prodIndex" class="produto-container">
                    <div class="produto-header">
                        <span></span>
                        <div class="produto-nome-wrapper">
                            <strong class="produto-nome" :title="product.name">{{ truncateText(product.name, 35)
                                }}</strong>
                        </div>
                        <div class="produto-actions">
                            <button :class="!isEditMode ? 'disableBtn' : 'btn-icon'"
                                @click.stop="openEditProductModal(product, prodIndex)" title="Editar Nome">
                                <img class="action-btn img-btn-small" src="../../assets/EDIT-PENCIL.svg" />
                            </button>
                            <button :class="!isEditMode ? 'disableBtn' : 'btn-icon'"
                                @click="removeProduct(activeAreaIndex, prodIndex)" title="Excluir Produto">
                                <img class="action-btn img-btn-small" src="../../assets/excluir.png" />
                            </button>
                        </div>
                    </div>

                    <div class="indicadores-grid">
                        <div v-for="colKey in columnKeys" :key="colKey" class="indicador-coluna"
                            :style="{ backgroundColor: columnSettings[colKey].color }">
                            <div class="col-header">
                                <span class="title-grid" :title="columnSettings[colKey].label">
                                    {{ truncateText(columnSettings[colKey].label, 35) }}
                                </span>
                                <button :class="!isEditMode ? 'disableBtn disable-config' : 'btn-config'"
                                    @click="openGridConfigModal(colKey)" title="Configurar Coluna">
                                    <i class="fa fa-cog"></i>
                                </button>
                            </div>
                            <div class="cards-container">
                                <div v-for="(indicator, indIndex) in product[colKey]" :key="indIndex"
                                    class="indicator-wrapper">
                                    <div class="indicador-card"
                                        :ref="`indicator-${activeAreaIndex}-${prodIndex}-${colKey}-${indIndex}`"
                                        @click="handleCardClick(activeAreaIndex, prodIndex, colKey, indIndex, $event)"
                                        :class="[computedCardClasses(indicator), { 'target-highlight': isPotentialTarget(activeAreaIndex, prodIndex, colKey, indIndex) }]"
                                        @dblclick="openIndicatorModal(activeAreaIndex, prodIndex, colKey, indIndex)">
                                        <div class="card-body">
                                            <div class="row1" :title="currentIndicatorData(indicator.Id).Name">
                                                {{ currentIndicatorData(indicator.Id).Name }}
                                                <span v-if="currentIndicatorData(indicator.Id).Unit"> ({{
                                                    currentIndicatorData(indicator.Id).Unit }})</span>
                                                <div v-if="indicator.Occurrences > 0 && !isEditMode"
                                                    class="count-occurrence-1"
                                                    @click.stop="openModalOccurrences(indicator)">
                                                    <div class="count-occurrence-2"
                                                        :title="`${indicator.Occurrences} - Ocorrências não tratadas`">
                                                        <div v-if="indicator.Occurrences < 99"
                                                            class="count-occurrence-text">
                                                            {{ indicator.Occurrences }}
                                                        </div>
                                                        <div v-else class="count-occurrence-text-1">+99</div>
                                                    </div>
                                                </div>
                                                <div v-if="indicator.RTAs > 0 && !isEditMode" class="count-rta-1"
                                                    :class="{ 'has-rta-not-fcas': indicator.Occurrences == 0 }"
                                                    @click.stop="openModalRTA(indicator)">
                                                    <div class="count-rta-2"
                                                        :title="`${indicator.RTAs} - RTAs não tratadas`">
                                                        <div v-if="indicator.RTAs < 99" class="count-rta-text">
                                                            {{ indicator.RTAs }}
                                                        </div>
                                                        <div v-else class="count-rta-text-1">+99</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row2">
                                                <div class="row2Col3">{{ parseNumber(indicator.LowerLimit) }}</div>
                                                <div class="row2Col2">{{ parseNumber(indicator.CurrentValue) }}</div>
                                                <div class="row2Col1">{{ parseNumber(indicator.UpperLimit) }}</div>
                                            </div>
                                        </div>
                                        <button :class="!isEditMode ? 'disableBtn' : 'btn-remove'"
                                            @click.stop="handleRemoveIndicator(activeAreaIndex, prodIndex, colKey, indIndex)"
                                            title="Excluir Indicador">
                                            <i class="fa fa-times"></i>
                                        </button>
                                        <button :class="!isEditMode || indicator.Id == 0 ? 'disableBtn' : 'btn-add-info'"
                                            @click.stop="toggleIndicatorInfo(activeAreaIndex, prodIndex, colKey, indIndex)"
                                            :title="(product[colKey][indIndex].infos && product[colKey][indIndex].infos.length > 0)
                                                ? 'Remover Informação'
                                                : 'Adicionar Informação'">
                                            <i class="fa fa-info-circle"></i>
                                        </button>
                                    </div>
                                    <div v-if="indicator.infos && indicator.infos.length" class="info-wrapper">
                                        <div class="info-card"
                                            :ref="`info-${activeAreaIndex}-${prodIndex}-${colKey}-${indIndex}`">
                                            <div v-if="indicator.editingInfo">
                                                <b-form-group class="mt-4" label="Real Safra Anterior:">
                                                    <b-form-input v-model="indicator.tempInfo.LastCropReal"
                                                        type="text" />
                                                </b-form-group>
                                                <b-form-group label="Meta Safra:">
                                                    <b-form-input v-model="indicator.tempInfo.CropTarget" type="text" />
                                                </b-form-group>
                                                <b-form-group>
                                                    <b-form-checkbox v-model="indicator.tempInfo.ShowChronicTrigger">
                                                        Exibir Gatilho Crônico
                                                    </b-form-checkbox>
                                                </b-form-group>
                                                <b-form-group v-show="indicator.tempInfo.ShowChronicTrigger"
                                                    label="Gatilho Crônico:">
                                                    <b-form-input v-model="indicator.tempInfo.ChronicTrigger" />
                                                </b-form-group>
                                                <b-form-group>
                                                    <b-form-checkbox v-model="indicator.tempInfo.ShowCriticalTrigger">
                                                        Exibir Gatilho Crítico
                                                    </b-form-checkbox>
                                                </b-form-group>
                                                <b-form-group v-show="indicator.tempInfo.ShowCriticalTrigger"
                                                    label="Gatilho Crítico:">
                                                    <b-form-input v-model="indicator.tempInfo.CriticalTrigger" />
                                                </b-form-group>
                                                <div class="btn-group-info">
                                                    <img class="action-btn" width="30" height="30"
                                                        src="@/assets/salvar.png" title="Salvar"
                                                        @click="saveInfoEdit(indicator)" />
                                                    <img class="action-btn ml-2 exit-btn-withoutmr" width="30"
                                                        height="30" src="@/assets/sair.png" title="Cancelar"
                                                        @click="cancelInfoEdit(indicator)" />
                                                </div>
                                            </div>
                                            <div v-else>
                                                <p :title="indicator.infos[0].LastCropReal">
                                                    <strong>Real Safra Anterior:</strong>
                                                    {{ truncateText(indicator.infos[0].LastCropReal, 28) }}
                                                </p>
                                                <p :title="indicator.infos[0].CropTarget">
                                                    <strong>Meta Safra:</strong>
                                                    {{ truncateText(indicator.infos[0].CropTarget, 28) }}
                                                </p>
                                                <p v-if="indicator.ShowChronicTrigger"
                                                    :title="indicator.infos[0].ChronicTrigger">
                                                    <strong>Gatilho Crônico:</strong>
                                                    {{ truncateText(indicator.infos[0].ChronicTrigger, 28) }}
                                                </p>
                                                <p v-if="indicator.ShowCriticalTrigger"
                                                    :title="indicator.infos[0].CriticalTrigger">
                                                    <strong>Gatilho Crítico:</strong>
                                                    {{ truncateText(indicator.infos[0].CriticalTrigger, 28) }}
                                                </p>
                                            </div>
                                        </div>
                                        <button
                                            :class="!isEditMode ? 'disableBtn btn-edit-info-disabled' : 'btn-edit-info'"
                                            @click.stop="toggleEditInfo(indicator)" title="Editar Informação">
                                            <img class="action-btn img-btn-small" src="../../assets/EDIT-PENCIL.svg" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <button :class="!isEditMode ? 'disableBtn disable-indicator' : 'btn-add-indicator'"
                                @click="addIndicator(activeAreaIndex, prodIndex, colKey)" title="Adicionar Indicador">
                                <img class="action-btn img-btn-small btn-add-ind" src="../../assets/plus-2.svg" />
                            </button>
                        </div>
                    </div>
                </div>
                <div class="add-product-wrapper">
                    <button :class="!isEditMode ? 'disableBtn' : 'btn-add-product'" @click="showAddProductModal"
                        title="Adicionar Produto">
                        <img class="action-btn img-btn" src="../../assets/add.png" />
                    </button>
                </div>

                <!-- SVG Overlay para as Conexões -->
                <svg class="connections-overlay" xmlns="http://www.w3.org/2000/svg" @dblclick="openArrowColorModal">
                    <defs>
                        <marker v-for="(conn, index) in validConnections" :key="index" :id="'arrow-' + index"
                            markerUnits="userSpaceOnUse" markerWidth="10" markerHeight="10" refX="0" refY="3"
                            orient="auto-start-reverse">
                            <path v-if="!conn.noArrow" d="M0,0 L0,6 L9,3 z" :fill="conn.color || '#000'" />
                        </marker>
                    </defs>
                    <path v-for="(conn, index) in validConnections" :key="index" :d="getConnectionPath(conn)"
                        :stroke="conn.color || '#000'" :stroke-width="conn.thickness || 2" fill="none"
                        :marker-end="!conn.noArrow ? 'url(#arrow-' + index + ')' : ''" stroke-linejoin="miter"
                        stroke-linecap="square" @click="selectConnection(index)"
                        :class="['line-connection', { 'selected-line': selectedConnectionIndex === index }]"
                        style="cursor:pointer; pointer-events:all;" />
                </svg>
            </div>

            <!-- Modais -->
            <b-modal ref="rotationConfigModal" id="rotation-config-modal" title="Configurar Rotação de Áreas"
                @hide="cancelRotationConfigModal">
                <div class="modal-body">
                    <b-form-group label="Ativar Rotação das Áreas?">
                        <b-form-checkbox v-model="rotationActive">
                            {{ rotationActive ? 'Rotação entre áreas ativada' : 'Rotação entre áreas desativada' }}
                        </b-form-checkbox>
                    </b-form-group>
                    <b-form-group label="Tempo de rotação (Segundos):">
                        <b-form-input type="number" v-model="rotationTime" min="1" />
                    </b-form-group>
                    <b-form-group label="Áreas para Rotacionar:">
                        <div class="rotation-areas-container">
                            <b-button v-for="(area, index) in areas" :key="area.id"
                                :variant="rotationSelectedAreas.includes(area.id) ? 'success' : 'outline-secondary'"
                                class="rotation-area-button" @click="toggleAreaSelection(index)">
                                {{ area.name }}
                            </b-button>
                        </div>
                    </b-form-group>
                </div>
                <template #modal-footer>
                    <img class="action-btn" width="30" height="30" src="@/assets/salvar.png" title="Salvar"
                        @click="saveRotationConfigModal" />
                    <img class="action-btn ml-2 exit-btn" width="30" height="30" src="@/assets/sair.png"
                        title="Cancelar" @click="cancelRotationConfigModal" />
                </template>
            </b-modal>

            <b-modal ref="editProductModal" id="edit-product-modal" title="Editar Nome do Produto">
                <b-form-group label="Nome do Produto:">
                    <b-form-input v-model="editProductName" placeholder="Digite o novo nome" />
                </b-form-group>
                <template #modal-footer>
                    <img class="action-btn" width="30" height="30" src="@/assets/salvar.png" title="Salvar"
                        @click="saveEditProduct" />
                    <img class="action-btn ml-2 exit-btn" width="30" height="30" src="@/assets/sair.png"
                        title="Cancelar" @click="cancelEditProduct" />
                </template>
            </b-modal>

            <b-modal ref="addAreaModal" id="add-area-modal" title="Adicionar Nova Área">
                <b-form-group label="Nome da Área:">
                    <b-form-input v-model="newAreaName" placeholder="Informe o nome da área" />
                </b-form-group>
                <template #modal-footer>
                    <img class="action-btn" width="30" height="30" src="@/assets/salvar.png" title="Salvar"
                        @click="confirmAddArea" />
                    <img class="action-btn ml-2 exit-btn" width="30" height="30" src="@/assets/sair.png"
                        title="Cancelar" @click="cancelAddArea" />
                </template>
            </b-modal>

            <b-modal ref="addProductModal" id="add-product-modal" title="Adicionar Novo Produto">
                <b-form-group label="Nome do Produto:">
                    <b-form-input v-model="newProductName" placeholder="Informe o nome do produto" />
                </b-form-group>
                <template #modal-footer>
                    <img class="action-btn" width="30" height="30" src="@/assets/salvar.png" title="Salvar"
                        @click="confirmAddProduct" />
                    <img class="action-btn ml-2 exit-btn" width="30" height="30" src="@/assets/sair.png"
                        title="Cancelar" @click="cancelAddProduct" />
                </template>
            </b-modal>

            <!-- Modal: Selecionar Indicador (PGDI) -->
            <b-modal ref="indicatorModal" id="indicator-modal" title="Selecionar Indicador (PGDI)">
                <div class="modal-body">
                    <!-- Dropdown de seleção -->
                    <b-form-select v-model="selectedPgdiIndicatorName" class="mb-1 input-pentagro">
                        <option disabled value="">Selecione um Indicador</option>
                        <option v-for="(ind, index) in pgdiIndicators" :key="ind.Name + '-' + index" :value="ind.Name">
                            {{ ind.Name }} ({{ ind.Unit }})
                        </option>
                    </b-form-select>

                    <!-- Detalhes do Indicador -->
                    <div v-if="selectedPgdiIndicator.Name" class="pgdi-indicator-details">
                        <p class="p-firstitem"><strong>Nome:</strong> {{ selectedPgdiIndicator.Name }}</p>
                        <p><strong>Unidade:</strong> {{ selectedPgdiIndicator.Unit }}</p>
                        <p><strong>Valor Atual:</strong> {{ selectedPgdiIndicator.CurrentValue }}</p>
                        <p><strong>Limite Inferior:</strong> {{ selectedPgdiIndicator.LowerLimit }}</p>
                        <p><strong>Limite Superior:</strong> {{ selectedPgdiIndicator.UpperLimit }}</p>

                        <!-- Campos sincronizados -->
                        <div class="form-group mt-2">
                            <b-form-group class="mt-4" label="Real Safra Anterior:">
                                <b-form-input v-model="indicatorModalTemp.LastCropReal" type="text"
                                    class="input-pentagro" />
                            </b-form-group>
                        </div>

                        <div class="form-group">
                            <b-form-group label="Meta Safra:">
                                <b-form-input v-model="indicatorModalTemp.CropTarget" type="text"
                                    class="input-pentagro" />
                            </b-form-group>
                        </div>

                        <!-- Gatilhos -->
                        <b-form-group class="mt-4">
                            <b-form-checkbox v-model="indicatorModalTemp.ShowChronicTrigger">
                                Exibir Gatilho Crônico na Informação
                            </b-form-checkbox>
                        </b-form-group>

                        <div v-if="indicatorModalTemp.ShowChronicTrigger" class="form-group ml-4">
                            <b-form-group label="Configurar Gatilho Crônico:">
                                <b-form-input v-model="indicatorModalTemp.ChronicTrigger" type="text"
                                    placeholder="Informe o gatilho crônico" @keydown.enter.prevent
                                    class="input-pentagro" />
                            </b-form-group>
                        </div>

                        <b-form-group class="mt-4">
                            <b-form-checkbox v-model="indicatorModalTemp.ShowCriticalTrigger">
                                Exibir Gatilho Crítico na Informação
                            </b-form-checkbox>
                        </b-form-group>

                        <div v-if="indicatorModalTemp.ShowCriticalTrigger" class="form-group ml-4">
                            <b-form-group label="Configurar Gatilho Crítico:">
                                <b-form-input v-model="indicatorModalTemp.CriticalTrigger" type="text"
                                    placeholder="Informe o gatilho crítico" @keydown.enter.prevent
                                    class="input-pentagro" />
                            </b-form-group>
                        </div>
                    </div>

                    <!-- Opção de criar Info -->
                    <b-form-group v-if="selectedPgdiIndicator.Name" class="mt-4">
                        <b-form-checkbox v-model="indicatorModalTemp.AddInfoForSelectedPgdi">
                            Criar Informação automaticamente
                        </b-form-checkbox>
                    </b-form-group>
                </div>

                <!-- Footer do modal -->
                <template #modal-footer>
                    <img class="action-btn" width="30" height="30" src="@/assets/salvar.png" title="Salvar"
                        @click="saveIndicatorModal" />
                    <img class="action-btn ml-2 exit-btn" width="30" height="30" src="@/assets/sair.png"
                        title="Cancelar" @click="cancelIndicatorModal" />
                </template>
            </b-modal>

            <b-modal ref="gridConfigModal" id="grid-config-modal" title="Configurar Coluna">
                <b-form-group label="Nome da Coluna:">
                    <b-form-input v-model="gridModalData.label" />
                </b-form-group>
                <b-form-group :label="$t('cor-de-fundo')">
                    <div class="color-radio-group">
                        <label v-for="opt in gridColorOptions" :key="opt.value"
                            :class="['color-option', { selected: gridModalData.color === opt.value }]"
                            :style="{ backgroundColor: opt.value }">
                            <input type="radio" v-model="gridModalData.color" :value="opt.value" />
                            {{ opt.label }}
                        </label>
                    </div>
                </b-form-group>
                <template #modal-footer>
                    <img class="action-btn" width="30" height="30" src="@/assets/salvar.png" title="Salvar"
                        @click="saveGridConfigModal" />
                    <img class="action-btn ml-2 exit-btn" width="30" height="30" src="@/assets/sair.png"
                        title="Cancelar" @click="cancelGridConfigModal" />
                </template>
            </b-modal>

            <b-modal ref="arrowColorModal" id="arrow-color-modal" title="Configurar Cor da Seta">
                <b-form-group :label="$t('cor-de-fundo')">
                    <div class="color-radio-group">
                        <label v-for="opt in arrowColorOptions" :key="opt.value"
                            :class="['color-option', { selected: arrowColorSelected === opt.value }]"
                            :style="{ backgroundColor: opt.value }">
                            <input type="radio" v-model="arrowColorSelected" :value="opt.value" />
                            {{ opt.label }}
                        </label>
                    </div>
                </b-form-group>
                <template #modal-footer>
                    <img class="action-btn ml-2 exit-btn" width="30" height="30" src="@/assets/sair.png"
                        title="Cancelar" @click="cancelArrowColorModal" />
                    <img class="action-btn" width="30" height="30" src="@/assets/salvar.png" title="Salvar"
                        @click="saveArrowColorModal" />
                </template>
            </b-modal>
            <b-modal ref="confirmDeleteAreaModal" id="confirm-delete-area-modal" title="Confirmar Exclusão de Área">
                <p>Tem certeza que deseja excluir a área?</p>
                <template #modal-footer>
                    <img class="action-btn" width="30" height="30" src="@/assets/sair.png" title="Cancelar"
                        @click="cancelDeleteArea" />
                    <img class="action-btn" width="30" height="30" src="@/assets/assinarEconfirmar.png" title="Salvar"
                        @click="confirmDeleteArea" />
                </template>
            </b-modal>

            <b-modal id="UntratedOccurrences" size="xl" hide-footer>
                <div slot="modal-title" class="img-slot">
                    <img style="width: 33px; height: 33px; margin-right: 10px" src="@/assets/circular138.png"
                        alt="salvar_ocorrencia" />
                    <label>{{ $t("untrated-occurrences") }}</label>
                </div>
                <ManageAllOccurrences :indicatorInfo="indicatorSelected" :reloadOccFunct="loadConfiguration"
                    :showActionResponsible="false" :showInfluencingParams="true"></ManageAllOccurrences>
            </b-modal>
        </div>
    </div>
</template>

<script>
import { BModal, BButton, BFormInput, BFormGroup, BFormSelect, BFormCheckbox } from "bootstrap-vue";
import axios from "axios";
import { urlMainAPI } from "../../global";
import ManageAllOccurrences from '../manageAllOccurrences/ManageAllOccurrences.vue';
import { mapState } from "vuex";

export default {
    name: "InfluenceTree",
    components: { BModal, BButton, BFormInput, BFormGroup, BFormSelect, BFormCheckbox, ManageAllOccurrences },
    data() {
        return {
            selectedAreaIndex: null,
            indicatorTimer: null,
            isLoading: true,
            pgdiIndicators: [],
            selectedPgdiIndicatorName: null,
            rotationActive: false,
            rotationTime: 15,
            rotationSelectedAreas: [],
            areaRotationTimer: null,
            isEditMode: false,
            activeTab: 1,
            areas: [{ id: 1, name: "Área 1", editing: false, produtos: [], isDeleting: false, connections: [] }],
            newAreaName: "",
            newProductName: "",
            columnSettings: {
                gestorIndicators: { label: "Gestor", color: "#4CAF50" },
                supervisorIndicators: { label: "Supervisor", color: "#0D47A1" },
                liderEquipeIndicators: { label: "Líder/Equipe", color: "#64B5F6" },
            },
            columnKeys: ["gestorIndicators", "supervisorIndicators", "liderEquipeIndicators"],
            gridModalData: { label: "", color: "" },
            gridModalKey: "",
            gridColorOptions: [
                { value: "#26806c", label: "Verde" },
                { value: "#70297A", label: "Roxo" },
                { value: "#254E70", label: "Azul" },
                { value: "#808080", label: "Cinza" },
                { value: "#bf0603", label: "Vermelho" },
                { value: "#f6ae2d", label: "Amarelo" },
                { value: "#e85933", label: "Laranja" },
                { value: "#4CAF50", label: "Verde" },
                { value: "#0D47A1", label: "Azul Marinho" },
                { value: "#64B5F6", label: "Azul Claro" },
            ],
            selectedConnectionIndex: null,
            connectionConfig: { color: "#000", thickness: 2 },
            arrowColorOptions: [
                { value: "#000000", label: "Preto" },
                { value: "#26806c", label: "Verde" },
                { value: "#70297A", label: "Roxo" },
                { value: "#254E70", label: "Azul" },
                { value: "#808080", label: "Cinza" },
                { value: "#bf0603", label: "Vermelho" },
                { value: "#f6ae2d", label: "Amarelo" },
                { value: "#e85933", label: "Laranja" },
            ],
            arrowColorSelected: "#000000",
            editProductName: "",
            productToEdit: null,
            productIndexToEdit: null,
            modalContext: { areaIndex: null, prodIndex: null, colKey: "", indicatorIndex: null },
            selectedIndicatorsInfo: [],
            connectionStartCard: null,
            indicatorIdsOnScreen: [],
            indicatorModalTemp: {
                LastCropReal: null,
                CropTarget: null,
                ChronicTrigger: "",
                CriticalTrigger: "",
                ShowChronicTrigger: false,
                ShowCriticalTrigger: false,
                AddInfoForSelectedPgdi: false,
            },
            indicatorSelected: {},
        };
    },
    computed: {
        ...mapState(["user"]),
        activeArea() {
            return this.areas.find((area) => area.id === this.activeTab);
        },
        activeAreaIndex() {
            return this.areas.findIndex((area) => area.id === this.activeTab);
        },
        validConnections() {
            return this.activeArea && this.activeArea.connections ? this.activeArea.connections : [];
        },
        pgdiIndicatorOptions() {
            return this.pgdiIndicators.map((ind) => ({ text: ind.Name, value: ind.Name }));
        },
        selectedPgdiIndicator() {
            return (
                this.pgdiIndicators.find((ind) => ind.Name === this.selectedPgdiIndicatorName) || {
                    AddInfoForSelectedPgdi: false,
                }
            );
        },
        gridIndicatorOptions() {
            const list = [];
            this.areas.forEach((area) => {
                area.produtos.forEach((produto) => {
                    this.columnKeys.forEach((key) => {
                        produto[key].forEach((ind) => {
                            list.push({ text: ind.Name, value: ind.Name, fullData: ind });
                        });
                    });
                });
            });
            return list;
        },
        currentIndicatorData() {
            return (indicatorId) => this.pgdiIndicators.find(ind => ind.Id === indicatorId) || {};
        }
    },
    watch: {
        selectedPgdiIndicatorName(newVal) {
            if (!this.modalContext || this.modalContext.areaIndex === null) return;
            const { areaIndex, prodIndex, colKey, indicatorIndex } = this.modalContext;
            const sel = this.pgdiIndicators.find((ind) => ind.Name === newVal);
            if (sel) {
                const localInd = this.areas[areaIndex].produtos[prodIndex][colKey][indicatorIndex];
                Object.assign(localInd, sel);
                if (localInd.infos && localInd.infos.length > 0) {
                    Object.assign(localInd.infos[0], sel);
                }
            }
        },
        isEditMode(newVal) {
            if (!newVal) {
                this.populateIndicatorIds();
                if (this.rotationActive) {
                    this.startAreaRotation();
                }
            } else {
                this.stopAreaRotation();
                if (this.indicatorTimer) {
                    clearInterval(this.indicatorTimer);
                    this.indicatorTimer = null;
                }
            }
        },
    },
    methods: {
        activeCurrentArea(area) {
            this.activeTab = area.id;
            this.onFullScreenChange();
        },
        setupInfoWatchers(indicator) {
            if (indicator._infoUnwatchFns) {
                indicator._infoUnwatchFns.forEach(unwatch => unwatch());
            }
            indicator._infoUnwatchFns = [];

            const fields = [
                'LastCropReal',
                'CropTarget',
                'ChronicTrigger',
                'CriticalTrigger',
                'ShowChronicTrigger',
                'ShowCriticalTrigger'
            ];

            fields.forEach(field => {
                const unwatch = this.$watch(
                    () => indicator.tempInfo?.[field],
                    (newVal) => {
                        indicator[field] = newVal;
                    },
                    { immediate: false }
                );
                indicator._infoUnwatchFns.push(unwatch);
            });
        },

        formateDate(date) {
            return new Date(date).toLocaleString("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            });
        },
        populateIndicatorIds() {
            const ids = new Set();
            this.areas.forEach((area) => {
                area.produtos.forEach((produto) => {
                    this.columnKeys.forEach((key) => {
                        produto[key].forEach((indicator) => {
                            if (indicator.Id) {
                                ids.add(indicator.Id);
                            }
                        });
                    });
                });
            });
            this.indicatorIdsOnScreen = Array.from(ids);
        },
        async updateIndicatorValues(forceUpdate = false) {
            try {
                if (this.indicatorIdsOnScreen.length === 0) return;

                if (forceUpdate) this.openToast("Atualizando valores...", "Atualizando", "success");

                const response = await axios.post(`${urlMainAPI}/update-values`, {
                    indicatorIds: this.indicatorIdsOnScreen,
                    ForceUpdate: forceUpdate
                });
                const data = response.data;
                if (data.LastUpdate) {
                    this.$store.commit("setDt1", `ÚLTIMA ATUALIZAÇÃO: ${this.formateDate(data.LastUpdate.toString())}`);
                }
                if (data.Indicators && data.Indicators.length > 0) {
                    data.Indicators.forEach(updated => {
                        this.areas.forEach(area => {
                            area.produtos.forEach(produto => {
                                this.columnKeys.forEach(key => {
                                    produto[key].forEach(indicator => {
                                        if (indicator.Id === updated.Id) {
                                            indicator.LowerLimit = updated.LowerLimit;
                                            indicator.UpperLimit = updated.UpperLimit;
                                            indicator.CurrentValue = updated.CurrentValue;
                                            indicator.LastUpdated = updated.LastUpdated;
                                            indicator.OutOfRange = updated.OutOfRange;
                                            indicator.Occurrences = updated.Occurrences;
                                            indicator.RTAs = updated.RTAs;
                                        }
                                    });
                                });
                            });
                        });
                    });

                    if (forceUpdate) this.openToast("Atualização realizada com sucesso!", "Sucesso", "success");

                } else {
                    console.log(data.Message);
                }
            } catch (error) {
                this.openToast(`Erro ao atualizar indicadores: ${error.message}`, "Erro", "danger");
            }
        },
        async loadPgdiIndicatorCards() {
            try {
                const response = await axios.get(`${urlMainAPI}/pgdi-indicators`);
                const updatedIndicators = response.data;
                this.pgdiIndicators = updatedIndicators;

                this.areas.forEach((area) => {
                    area.produtos.forEach((produto) => {
                        this.columnKeys.forEach((key) => {
                            produto[key].forEach((indicator) => {
                                const updated = updatedIndicators.find((u) => u.Id === indicator.Id);
                                if (updated) {
                                    indicator.LowerLimit = updated.LowerLimit;
                                    indicator.UpperLimit = updated.UpperLimit;
                                    indicator.CurrentValue = updated.CurrentValue;
                                    indicator.LastUpdated = updated.LastUpdated;
                                    indicator.OutOfRange = updated.OutOfRange;
                                }
                            });
                        });
                    });
                });

                this.$store.commit("setDt1", `ÚLTIMA ATUALIZAÇÃO: ${this.formateDate(new Date().toString())}`);
            } catch (error) {
                this.openToast(`Erro ao carregar indicadores PGDI: ${error.message}`, "Erro", "danger");
            }
        },
        async loadConfiguration() {
            try {
                const response = await axios.get(`${urlMainAPI}/getprocessconfigurations`);
                const configs = response.data;
                if (configs && configs.length > 0) {
                    this.areas = [];
                    configs.forEach((configItem) => {
                        this.$store.commit("setDt1", `ÚLTIMA ATUALIZAÇÃO: ${this.formateDate(configItem.Date)}`);
                        const config = configItem.Configuration;
                        this.$store.commit("setDt2", `ÚLTIMA REVISÃO: ${this.formateDate(config.LastRevision)}`);
                        const loadedProducts = config.Products || [];
                        const mappedProducts = loadedProducts.map((prod) => {
                            const mappedProd = {
                                name: prod.ProductName,
                                gestorIndicators: [],
                                supervisorIndicators: [],
                                liderEquipeIndicators: [],
                            };
                            if (prod.Grids && Array.isArray(prod.Grids)) {
                                prod.Grids.forEach((grid) => {
                                    if (grid.GridConfiguration === "gestorIndicators") {
                                        mappedProd.gestorIndicators = grid.IndicatorCards || [];
                                        if (grid.Color) {
                                            this.$set(this.columnSettings.gestorIndicators, "color", grid.Color);
                                        }
                                        if (grid.Name) {
                                            this.$set(this.columnSettings.gestorIndicators, "label", grid.Name);
                                        }
                                    } else if (grid.GridConfiguration === "supervisorIndicators") {
                                        mappedProd.supervisorIndicators = grid.IndicatorCards || [];
                                        if (grid.Color) {
                                            this.$set(this.columnSettings.supervisorIndicators, "color", grid.Color);
                                        }
                                        if (grid.Name) {
                                            this.$set(this.columnSettings.supervisorIndicators, "label", grid.Name);
                                        }
                                    } else if (grid.GridConfiguration === "liderEquipeIndicators") {
                                        mappedProd.liderEquipeIndicators = grid.IndicatorCards || [];
                                        if (grid.Color) {
                                            this.$set(this.columnSettings.liderEquipeIndicators, "color", grid.Color);
                                        }
                                        if (grid.Name) {
                                            this.$set(this.columnSettings.liderEquipeIndicators, "label", grid.Name);
                                        }
                                    }
                                    if (grid.IndicatorCards) {
                                        grid.IndicatorCards.forEach((card) => {
                                            const pgdiIndex = this.pgdiIndicators.findIndex((ind) => ind.Name === card.Name);
                                            if (pgdiIndex !== -1) {
                                                Object.assign(this.pgdiIndicators[pgdiIndex], card);
                                            }
                                            if (
                                                card.AddInfoForSelectedPgdi &&
                                                (card.LastCropReal || card.CropTarget || card.ChronicTrigger || card.CriticalTrigger)
                                            ) {
                                                card.infos = [
                                                    {
                                                        Name: card.Name,
                                                        LastCropReal: card.LastCropReal || null,
                                                        CropTarget: card.CropTarget || null,
                                                        ChronicTrigger: card.ChronicTrigger || null,
                                                        CriticalTrigger: card.CriticalTrigger || null,
                                                        ShowCriticalTrigger: card.ShowCriticalTrigger || null,
                                                        ShowChronicTrigger: card.ShowChronicTrigger || null,
                                                        AddInfoForSelectedPgdi: card.AddInfoForSelectedPgdi || null,
                                                    },
                                                ];
                                            }
                                        });
                                    }
                                });
                            }
                            return mappedProd;
                        });
                        let areaConnections = [];
                        if (config.Connections) {
                            try {
                                areaConnections =
                                    typeof config.Connections === "string"
                                        ? JSON.parse(config.Connections)
                                        : config.Connections;
                            } catch (error) {
                                this.openToast(`Erro ao converter config.Connections para array: ${error.message}`, "Erro", "danger");
                                areaConnections = [];
                            }
                        }
                        this.areas.push({
                            id: configItem.Id,
                            name: configItem.Name,
                            editing: false,
                            produtos: mappedProducts,
                            connections: areaConnections,
                        });
                    });
                    if (this.areas.length > 0) {
                        this.activeTab = this.areas[0].id;
                    }
                    this.populateIndicatorIds();
                    if (this.rotationActive && !this.isEditMode) {
                        this.startAreaRotation();
                    }
                } else {
                    this.areas = []
                }
            } catch (error) {
                this.openToast("Erro ao carregar as configurações", "Erro", "danger");
            }
        },
        async sendConfiguration() {
            this.isEditMode = !this.isEditMode;
            this.isLoading = true;
            const processConfigurations = [];
            this.areas.forEach((area, areaIndex) => {
                const products = [];
                area.produtos.forEach((produto) => {
                    const productJson = {
                        ProductName: produto.name,
                        Grids: [
                            {
                                GridConfiguration: "gestorIndicators",
                                Name: this.columnSettings.gestorIndicators.label || "Gestor",
                                Color: this.columnSettings.gestorIndicators.color,
                                IndicatorCards: produto.gestorIndicators.map((ind) => ({
                                    Id: ind.Id || 0,
                                    LastCropReal: ind.infos && ind.infos[0] ? ind.infos[0].LastCropReal : "-9999",
                                    CropTarget: ind.infos && ind.infos[0] ? ind.infos[0].CropTarget : "-9999",
                                    ChronicTrigger: ind.infos && ind.infos[0] ? ind.infos[0].ChronicTrigger : null,
                                    CriticalTrigger: ind.infos && ind.infos[0] ? ind.infos[0].CriticalTrigger : null,
                                    ShowCriticalTrigger: ind.ShowCriticalTrigger,
                                    ShowChronicTrigger: ind.ShowChronicTrigger,
                                    AddInfoForSelectedPgdi: ind.AddInfoForSelectedPgdi,
                                })),
                            },
                            {
                                GridConfiguration: "supervisorIndicators",
                                Name: this.columnSettings.supervisorIndicators.label || "Supervisor",
                                Color: this.columnSettings.supervisorIndicators.color,
                                IndicatorCards: produto.supervisorIndicators.map((ind) => ({
                                    Id: ind.Id || 0,
                                    LastCropReal: ind.infos && ind.infos[0] ? ind.infos[0].LastCropReal : "-9999",
                                    CropTarget: ind.infos && ind.infos[0] ? ind.infos[0].CropTarget : "-9999",
                                    ChronicTrigger: ind.infos && ind.infos[0] ? ind.infos[0].ChronicTrigger : null,
                                    CriticalTrigger: ind.infos && ind.infos[0] ? ind.infos[0].CriticalTrigger : null,
                                    ShowCriticalTrigger: ind.ShowCriticalTrigger,
                                    ShowChronicTrigger: ind.ShowChronicTrigger,
                                    AddInfoForSelectedPgdi: ind.AddInfoForSelectedPgdi,
                                })),
                            },
                            {
                                GridConfiguration: "liderEquipeIndicators",
                                Name: this.columnSettings.liderEquipeIndicators.label || "Líder",
                                Color: this.columnSettings.liderEquipeIndicators.color,
                                IndicatorCards: produto.liderEquipeIndicators.map((ind) => ({
                                    Id: ind.Id || 0,
                                    LastCropReal: ind.infos && ind.infos[0] ? ind.infos[0].LastCropReal : "-9999",
                                    CropTarget: ind.infos && ind.infos[0] ? ind.infos[0].CropTarget : "-9999",
                                    ChronicTrigger: ind.infos && ind.infos[0] ? ind.infos[0].ChronicTrigger : null,
                                    CriticalTrigger: ind.infos && ind.infos[0] ? ind.infos[0].CriticalTrigger : null,
                                    ShowCriticalTrigger: ind.ShowCriticalTrigger,
                                    ShowChronicTrigger: ind.ShowChronicTrigger,
                                    AddInfoForSelectedPgdi: ind.AddInfoForSelectedPgdi,
                                })),
                            },
                        ],
                    };
                    products.push(productJson);
                });
                const areaConnections = this.areas[areaIndex].connections;
                const lastRevision = new Date().toISOString();
                processConfigurations.push({
                    ProcessId: area.id,
                    ProcessName: area.name,
                    IsDeleting: area.isDeleting,
                    Products: products,
                    Connections: JSON.stringify(areaConnections),
                    LastRevision: lastRevision,
                });
            });
            this.updateConnections();
            await this.$nextTick();
            try {
                const url = `${urlMainAPI}/saveprocessconfiguration`;
                for (const config of processConfigurations) {
                    await axios.post(url, config);
                }
                this.$store.commit("setDt2", `ÚLTIMA REVISÃO: ${new Date().toLocaleString()}`);

                this.openToast("Configurações de todos os processos salvas com sucesso!", "Sucesso", "success");

                await this.loadConfiguration();
                await this.updateIndicatorValues(true);
            } catch (error) {
                this.openToast(`Erro ao salvar as configurações : ${error.message}`, "Erro", "danger");
            } finally {
                this.isLoading = false;
                this.isEditMode = false;
            }
        },

        async saveRotationInfo() {
            const payload = {
                RotationActive: this.rotationActive,
                Seconds: this.rotationTime,
                ProcessIds: this.rotationSelectedAreas,
            };
            try {
                await axios.post(`${urlMainAPI}/saveinforotationscreenprocess`, payload);

                this.openToast("Informações de rotação salvas com sucesso!", "Sucesso", "success");
            } catch (error) {
                this.openToast(`Erro ao salvar rotação: ${error.message}`, "Erro", "danger");
            }
        },

        async loadRotationInfo() {
            try {
                const response = await axios.get(`${urlMainAPI}/rotationscreenprocesss`);
                const rotationData = response.data;
                this.rotationTime = rotationData.Seconds;
                this.rotationActive = rotationData.RotationActive;
                this.rotationSelectedAreas = rotationData.ProcessIds;
            } catch (error) {
                this.openToast("Erro ao carregar as informações de rotação!", "Erro", "danger");
            }
        },

        startAreaRotation() {
            if (!this.rotationActive || this.isEditMode) return;

            this.stopAreaRotation();
            this.areaRotationTimer = setInterval(() => {
                if (!this.isEditMode) {
                    const areasToRotate = this.rotationSelectedAreas.length
                        ? this.rotationSelectedAreas
                        : this.areas.map((area) => area.id);
                    if (!areasToRotate.length) return;
                    const currentAreaId = this.activeTab;
                    const currentIndex = areasToRotate.indexOf(currentAreaId);
                    const nextIndex =
                        currentIndex === -1 || currentIndex === areasToRotate.length - 1 ? 0 : currentIndex + 1;
                    const nextAreaId = areasToRotate[nextIndex];
                    this.activeTab = nextAreaId;
                    this.onFullScreenChange();
                }
            }, this.rotationTime * 1000);
        },

        stopAreaRotation() {
            if (this.areaRotationTimer) {
                clearInterval(this.areaRotationTimer);
                this.areaRotationTimer = null;
            }
            if (this.indicatorTimer) {
                clearInterval(this.indicatorTimer);
                this.indicatorTimer = null;
            }
        },

        openRotationConfigModal() {
            this.$refs.rotationConfigModal.show();
        },

        cancelRotationConfigModal() {
            this.$refs.rotationConfigModal.hide();
        },

        async saveRotationConfigModal() {
            await this.saveRotationInfo();
            if (this.rotationActive) {
                this.startAreaRotation();
            } else {
                this.stopAreaRotation();
            }
            this.$refs.rotationConfigModal.hide();
        },

        updateConnections() {
            const areaIndex = this.activeAreaIndex;
            if (areaIndex === null || areaIndex === -1) return;
            const connections = this.areas[areaIndex].connections;
            connections.forEach((conn) => {
                if (conn.isCardConnection) {
                    const sourceRef = `indicator-${conn.from.areaIndex}-${conn.from.prodIndex}-${conn.from.colKey}-${conn.from.indicatorIndex}`;
                    const targetRef = `indicator-${conn.to.areaIndex}-${conn.to.prodIndex}-${conn.to.colKey}-${conn.to.indicatorIndex}`;
                    const sourceEl = this.$refs[sourceRef] ? this.$refs[sourceRef][0] : null;
                    const targetEl = this.$refs[targetRef] ? this.$refs[targetRef][0] : null;
                    if (sourceEl && targetEl) {
                        const sourceSide = this.getAnchorSide(conn.from.colKey, true);
                        conn.fromPoint = this.getAnchorPoint(sourceEl, sourceSide);
                        const targetSide = this.getAnchorSide(conn.to.colKey, false);
                        conn.toPoint = this.getAnchorPoint(targetEl, targetSide);
                    }
                } else if (conn.isInfo) {
                    const indicatorRef = `indicator-${conn.from.areaIndex}-${conn.from.prodIndex}-${conn.from.colKey}-${conn.from.indicatorIndex}`;
                    const infoRef = `info-${conn.from.areaIndex}-${conn.from.prodIndex}-${conn.from.colKey}-${conn.from.indicatorIndex}`;
                    const indicatorEl = this.$refs[indicatorRef] ? this.$refs[indicatorRef][0] : null;
                    const infoEl = this.$refs[infoRef] ? this.$refs[infoRef][0] : null;
                    if (indicatorEl && infoEl) {
                        const svg = document.querySelector(".connections-overlay");
                        const svgRect = svg.getBoundingClientRect();
                        const indRect = indicatorEl.getBoundingClientRect();
                        const infoRect = infoEl.getBoundingClientRect();
                        const from = { x: indRect.left + indRect.width / 2 - svgRect.left, y: indRect.bottom - svgRect.top };
                        const to = { x: infoRect.left + infoRect.width / 2 - svgRect.left, y: infoRect.top - svgRect.top };
                        conn.from = { ...conn.from, ...from };
                        conn.to = { ...conn.to, ...to };
                    }
                }
            });
        },

        handleCardClick(areaIndex, prodIndex, colKey, indicatorIndex, event) {
            if (!this.isEditMode) return;
            if (this.connectionStartCard && this.connectionStartCard.areaIndex !== areaIndex) {
                this.openToast("Conexões entre processos não são permitidas.", "Atenção", "warning");
                this.connectionStartCard = null;
                return;
            }
            if (!this.connectionStartCard) {
                this.connectionStartCard = { areaIndex, prodIndex, colKey, indicatorIndex, el: event.currentTarget };
                return;
            }
            if (
                this.connectionStartCard.areaIndex === areaIndex &&
                this.connectionStartCard.prodIndex === prodIndex &&
                this.connectionStartCard.colKey === colKey &&
                this.connectionStartCard.indicatorIndex === indicatorIndex
            ) {
                this.connectionStartCard = null;
                return;
            }
            const sourceCol = this.connectionStartCard.colKey;
            const targetCol = colKey;
            if (sourceCol === targetCol) {
                this.openToast("Não é permitido conectar indicadores do mesmo grid.", "Atenção", "warning");
                this.connectionStartCard = null;
                return;
            }
            if (
                (sourceCol === "gestorIndicators" && targetCol === "liderEquipeIndicators") ||
                (sourceCol === "liderEquipeIndicators" && targetCol === "gestorIndicators")
            ) {
                this.openToast(`Conexão entre ${this.columnSettings.gestorIndicators.label} e ${this.columnSettings.liderEquipeIndicators.label} não é permitida.`, "Atenção", "warning");
                this.connectionStartCard = null;
                return;
            }
            if (sourceCol === "liderEquipeIndicators") {
                this.openToast(`Indicadores de ${this.columnSettings.liderEquipeIndicators.label} não podem iniciar conexões.`, "Atenção", "warning");
                this.connectionStartCard = null;
                return;
            }
            if (targetCol === "liderEquipeIndicators" && sourceCol !== "supervisorIndicators") {
                this.openToast(`Somente indicadores de ${this.columnSettings.supervisorIndicators.label} podem se conectar a indicadores de ${this.columnSettings.liderEquipeIndicators.label}.`, "Atenção", "warning");
                this.connectionStartCard = null;
                return;
            }
            if (sourceCol === "supervisorIndicators" && targetCol !== "liderEquipeIndicators") {
                this.openToast(`Indicadores de ${this.columnSettings.supervisorIndicators.label} só podem se conectar a indicadores de ${this.columnSettings.liderEquipeIndicators.label}.`, "Atenção", "warning");
                this.connectionStartCard = null;
                return;
            }
            if (sourceCol === "gestorIndicators" && targetCol !== "supervisorIndicators") {
                this.openToast(`Indicadores de ${this.columnSettings.gestorIndicators.label} só podem se conectar a indicadores de ${this.columnSettings.supervisorIndicators.label}.`, "Atenção", "warning");
                this.connectionStartCard = null;
                return;
            }
            if (this.connectionStartCard) {
                const existingConnection = this.areas[areaIndex].connections.some(conn =>
                    conn.isCardConnection && (
                        // Verifica conexão direta
                        (conn.from.areaIndex === this.connectionStartCard.areaIndex &&
                            conn.from.prodIndex === this.connectionStartCard.prodIndex &&
                            conn.from.colKey === this.connectionStartCard.colKey &&
                            conn.from.indicatorIndex === this.connectionStartCard.indicatorIndex &&
                            conn.to.areaIndex === areaIndex &&
                            conn.to.prodIndex === prodIndex &&
                            conn.to.colKey === colKey &&
                            conn.to.indicatorIndex === indicatorIndex) ||
                        // Verifica conexão inversa
                        (conn.to.areaIndex === this.connectionStartCard.areaIndex &&
                            conn.to.prodIndex === this.connectionStartCard.prodIndex &&
                            conn.to.colKey === this.connectionStartCard.colKey &&
                            conn.to.indicatorIndex === this.connectionStartCard.indicatorIndex &&
                            conn.from.areaIndex === areaIndex &&
                            conn.from.prodIndex === prodIndex &&
                            conn.from.colKey === colKey &&
                            conn.from.indicatorIndex === indicatorIndex)
                    )
                );

                if (existingConnection) {
                    this.openToast("Já existe uma conexão entre estes indicadores.", "Atenção", "warning");
                    this.connectionStartCard = null;
                    return;
                }
            }
            const sourceEl = this.connectionStartCard.el;
            const targetEl = event.currentTarget;
            const sourceSide = this.getAnchorSide(this.connectionStartCard.colKey, true);
            const targetSide = this.getAnchorSide(colKey, false);
            const sourcePoint = this.getAnchorPoint(sourceEl, sourceSide);
            const targetPoint = this.getAnchorPoint(targetEl, targetSide);

            // Verifica se já existe alguma conexão na área e pega a cor
            let connectionColor = this.connectionConfig.color;
            const existingConnections = this.areas[areaIndex].connections.filter(conn =>
                conn.isCardConnection && !conn.noArrow
            );

            if (existingConnections.length > 0) {
                // Usa a cor da primeira conexão encontrada
                connectionColor = existingConnections[0].color;
            }

            const connection = {
                from: { ...this.connectionStartCard },
                to: { areaIndex, prodIndex, colKey, indicatorIndex },
                fromPoint: sourcePoint,
                toPoint: targetPoint,
                color: connectionColor,
                thickness: this.connectionConfig.thickness,
                noArrow: false,
                isCardConnection: true,
            };

            this.areas[areaIndex].connections.push(connection);
            this.connectionStartCard = null;
        },
        isPotentialTarget(areaIndex, prodIndex, colKey, indicatorIndex) {
            if (!this.connectionStartCard) return false;
            if (
                this.connectionStartCard.areaIndex === areaIndex &&
                this.connectionStartCard.prodIndex === prodIndex &&
                this.connectionStartCard.colKey === colKey &&
                this.connectionStartCard.indicatorIndex === indicatorIndex
            ) {
                return false;
            }
            const sourceCol = this.connectionStartCard.colKey;
            if (sourceCol === "gestorIndicators") {
                if (colKey !== "supervisorIndicators") return false;
            } else if (sourceCol === "supervisorIndicators") {
                if (colKey !== "liderEquipeIndicators") return false;
            } else if (sourceCol === "liderEquipeIndicators") {
                return false;
            }
            const alreadyConnected = this.areas[this.connectionStartCard.areaIndex].connections.some(
                (conn) =>
                    conn.isCardConnection &&
                    conn.from.areaIndex === this.connectionStartCard.areaIndex &&
                    conn.from.prodIndex === this.connectionStartCard.prodIndex &&
                    conn.from.colKey === this.connectionStartCard.colKey &&
                    conn.from.indicatorIndex === this.connectionStartCard.indicatorIndex &&
                    conn.to.areaIndex === areaIndex &&
                    conn.to.prodIndex === prodIndex &&
                    conn.to.colKey === colKey &&
                    conn.to.indicatorIndex === indicatorIndex
            );
            if (alreadyConnected) return false;
            return true;
        },
        getAnchorSide(columnKey, isSource) {
            if (isSource && (columnKey === "gestorIndicators" || columnKey === "supervisorIndicators"))
                return "right";
            if (!isSource && (columnKey === "supervisorIndicators" || columnKey === "liderEquipeIndicators"))
                return "left";
            return isSource ? "right" : "left";
        },
        getAnchorPoint(element, side = "right") {
            const rect = element.getBoundingClientRect();
            const svg = document.querySelector(".connections-overlay");
            const svgRect = svg.getBoundingClientRect();
            const offsetX = rect.left - svgRect.left;
            const offsetY = rect.top - svgRect.top;
            return side === "right"
                ? { x: offsetX + rect.width, y: offsetY + rect.height / 2 }
                : { x: offsetX - 10, y: offsetY + rect.height / 2 };
        },
        getConnectionPath(conn) {
            if (conn.isCardConnection && conn.fromPoint && conn.toPoint) {
                const { x: x1, y: y1 } = conn.fromPoint;
                const { x: x2, y: y2 } = conn.toPoint;
                const xMid = (x1 + x2) / 2;
                return `M ${x1},${y1} L ${xMid},${y1} L ${xMid},${y2} L ${x2},${y2}`;
            }
            const { x: x1, y: y1 } = conn.from;
            const { x: x2, y: y2 } = conn.to;
            return `M ${x1},${y1} L ${x2},${y1} L ${x2},${y2}`;
        },
        selectConnection(index) {
            this.selectedConnectionIndex = index;
        },
        onGlobalClick(e) {
            if (!e.target.classList.contains("line-connection")) {
                this.selectedConnectionIndex = null;
            }
        },
        onKeyDown(e) {
            if ((e.key === "Delete" || e.key === "Backspace") && this.selectedConnectionIndex != null) {
                if (this.isEditMode) {
                    this.areas[this.activeAreaIndex].connections.splice(this.selectedConnectionIndex, 1);
                    this.selectedConnectionIndex = null;
                }
            }
            if (e.key === "Escape") {
                this.selectedConnectionIndex = null;
                this.connectionStartCard = null;
            }
        },
        showAddAreaModal() {
            this.newAreaName = "";
            this.$refs.addAreaModal.show();
        },
        cancelAddArea() {
            this.$refs.addAreaModal.hide();
        },
        confirmAddArea() {
            if (this.newAreaName.trim() !== "") {
                const lastId = this.areas.length > 0 ? Math.max(...this.areas.map(area => area.id)) : 0;
                const newId = lastId + 1;
                this.areas.push({ id: newId, name: this.newAreaName, editing: false, produtos: [], connections: [] });
            }
            this.$refs.addAreaModal.hide();
        },
        async removeArea(index) {
            this.isLoading = true;
            const areaId = this.areas[index].id;
            this.$set(this.areas[index], "isDeleting", true);
            this.rotationSelectedAreas = this.rotationSelectedAreas.filter((id) => id !== areaId);
            if (this.activeTab === areaId) {
                const nextActive = this.areas.find((area) => !area.isDeleting && area.id !== areaId);
                this.activeTab = nextActive ? nextActive.id : null;
            }
            await this.removeAreaInRotation(areaId);
            await this.sendConfiguration();
            this.isEditMode = true;
            this.isLoading = false;
        },
        showConfirmDeleteAreaModal(index) {
            this.selectedAreaIndex = index;
            this.$refs.confirmDeleteAreaModal.show();
        },
        confirmDeleteArea() {
            this.removeArea(this.selectedAreaIndex);
            this.$refs.confirmDeleteAreaModal.hide();
        },
        cancelDeleteArea() {
            this.$refs.confirmDeleteAreaModal.hide();
        },

        toggleEditArea(area) {
            area.editing = !area.editing;
        },
        openEditProductModal(product, prodIndex) {
            this.productToEdit = product;
            this.productIndexToEdit = prodIndex;
            this.editProductName = product.name;
            this.$refs.editProductModal.show();
        },
        cancelEditProduct() {
            this.productToEdit = null;
            this.productIndexToEdit = null;
            this.editProductName = "";
            this.$refs.editProductModal.hide();
        },
        saveEditProduct() {
            if (this.productToEdit && this.editProductName.trim() !== "") {
                this.productToEdit.name = this.editProductName.trim();
            }
            this.$refs.editProductModal.hide();
        },
        showAddProductModal() {
            this.newProductName = "";
            this.$refs.addProductModal.show();
        },
        cancelAddProduct() {
            this.$refs.addProductModal.hide();
        },
        confirmAddProduct() {
            if (this.newProductName.trim() !== "") {
                this.areas[this.activeAreaIndex].produtos.push({
                    name: this.newProductName,
                    gestorIndicators: [],
                    supervisorIndicators: [],
                    liderEquipeIndicators: [],
                });
            }
            this.$refs.addProductModal.hide();
        },
        removeProduct(areaIndex, prodIndex) {
            const connections = this.areas[areaIndex].connections;
            if (connections && connections.length > 0) {
                this.areas[areaIndex].connections = connections.filter(conn => {
                    return !(
                        (conn.from.areaIndex === areaIndex && conn.from.prodIndex === prodIndex) ||
                        (conn.to.areaIndex === areaIndex && conn.to.prodIndex === prodIndex)
                    );
                });
            }

            this.areas[areaIndex].produtos.splice(prodIndex, 1);
        },
        async removeAreaInRotation(areaIndex) {
            const url = `${urlMainAPI}/removeAreaInRotation/${areaIndex}`;
            await axios.get(url).then(() => { });
        },

        openIndicatorModal(areaIndex, prodIndex, colKey, indicatorIndex) {
            if (!this.isEditMode) return;

            this.modalContext = { areaIndex, prodIndex, colKey, indicatorIndex };
            const localInd = this.areas[areaIndex].produtos[prodIndex][colKey][indicatorIndex];
            const info = localInd.infos?.[0];

            this.selectedPgdiIndicatorName = localInd.Name && localInd.Name !== "Novo Indicador" ? localInd.Name : "";

            this.indicatorModalTemp = {
                LastCropReal: info?.LastCropReal ?? localInd.LastCropReal ?? null,
                CropTarget: info?.CropTarget ?? localInd.CropTarget ?? null,
                ChronicTrigger: info?.ChronicTrigger ?? localInd.ChronicTrigger ?? "",
                CriticalTrigger: info?.CriticalTrigger ?? localInd.CriticalTrigger ?? "",
                ShowChronicTrigger: info?.ShowChronicTrigger ?? localInd.ShowChronicTrigger ?? false,
                ShowCriticalTrigger: info?.ShowCriticalTrigger ?? localInd.ShowCriticalTrigger ?? false,
                AddInfoForSelectedPgdi: localInd.AddInfoForSelectedPgdi ?? false,
            };

            this.$refs.indicatorModal.show();
        },

        cancelIndicatorModal() {
            this.$refs.indicatorModal.hide();
        },

        saveIndicatorModal() {
            const { areaIndex, prodIndex, colKey, indicatorIndex } = this.modalContext;
            const localInd = this.areas[areaIndex].produtos[prodIndex][colKey][indicatorIndex];
            const selected = this.indicatorModalTemp;

            const exists = this.areas[areaIndex].produtos[prodIndex][colKey].some(
                (ind, i) => i !== indicatorIndex && ind.Name === this.selectedPgdiIndicatorName
            );
            if (exists) {
                this.openToast("Indicador já vinculado!", "Atenção", "warning");
                return;
            }

            localInd.Name = this.selectedPgdiIndicatorName;
            localInd.LastCropReal = selected.LastCropReal;
            localInd.CropTarget = selected.CropTarget;
            localInd.ChronicTrigger = selected.ChronicTrigger;
            localInd.CriticalTrigger = selected.CriticalTrigger;
            localInd.ShowChronicTrigger = selected.ShowChronicTrigger;
            localInd.ShowCriticalTrigger = selected.ShowCriticalTrigger;

            if (selected.AddInfoForSelectedPgdi) {
                localInd.AddInfoForSelectedPgdi = true;

                const newInfo = {
                    Name: localInd.Name,
                    LastCropReal: selected.LastCropReal,
                    CropTarget: selected.CropTarget,
                    ChronicTrigger: selected.ChronicTrigger,
                    CriticalTrigger: selected.CriticalTrigger,
                    ShowChronicTrigger: selected.ShowChronicTrigger,
                    ShowCriticalTrigger: selected.ShowCriticalTrigger,
                    AddInfoForSelectedPgdi: true,
                };

                if (!localInd.infos || localInd.infos.length === 0) {
                    this.$set(localInd, "infos", [newInfo]);
                    this.$nextTick(() => {
                        this.createInfoConnection(areaIndex, prodIndex, colKey, indicatorIndex);
                        this.updateConnections();
                    });
                } else {
                    this.$set(localInd.infos, 0, newInfo);
                }

            } else {
                localInd.AddInfoForSelectedPgdi = false;
            }

            this.$refs.indicatorModal.hide();
        },


        toggleIndicatorInfo(areaIndex, prodIndex, colKey, indicatorIndex) {
            const targetIndicator = this.areas[areaIndex].produtos[prodIndex][colKey][indicatorIndex];
            if (targetIndicator.infos && targetIndicator.infos.length > 0) {
                this.$set(targetIndicator, "infos", []);
                this.$set(targetIndicator, "AddInfoForSelectedPgdi", false);
                this.areas[areaIndex].connections = this.areas[areaIndex].connections.filter(
                    (conn) =>
                        !(
                            conn.isInfo &&
                            conn.from.areaIndex === areaIndex &&
                            conn.from.prodIndex === prodIndex &&
                            conn.from.colKey === colKey &&
                            conn.from.indicatorIndex === indicatorIndex
                        )
                );
                this.$nextTick(() => {
                    this.updateConnections();
                });
            } else {
                if (targetIndicator.Name === "Novo Indicador") {
                    this.openToast("Selecione um indicador válido antes de adicionar informação.", "Atenção", "warning");
                    return;
                }
                const infoData = {
                    Name: targetIndicator.Name,
                    LastCropReal: targetIndicator.LastCropReal || "-9999",
                    CropTarget: targetIndicator.CropTarget || "-9999",
                    ChronicTrigger: targetIndicator.ChronicTrigger || "-9999",
                    CriticalTrigger: targetIndicator.CriticalTrigger || "-9999",
                };
                this.$set(targetIndicator, "infos", [infoData]);
                this.$set(targetIndicator, "AddInfoForSelectedPgdi", true);
                this.$nextTick(() => {
                    this.createInfoConnection(areaIndex, prodIndex, colKey, indicatorIndex);
                    this.updateConnections();
                });
            }
        },

        createInfoConnection(areaIndex, prodIndex, colKey, indicatorIndex) {
            this.$nextTick(() => {
                const indicatorRef = `indicator-${areaIndex}-${prodIndex}-${colKey}-${indicatorIndex}`;
                const infoRef = `info-${areaIndex}-${prodIndex}-${colKey}-${indicatorIndex}`;
                const indicatorEl = this.$refs[indicatorRef];
                const infoEl = this.$refs[infoRef];
                if (!indicatorEl || !infoEl) return;
                const indRect = indicatorEl[0].getBoundingClientRect();
                const infoRect = infoEl[0].getBoundingClientRect();
                const svg = document.querySelector(".connections-overlay");
                const svgRect = svg.getBoundingClientRect();
                const from = { x: indRect.left + indRect.width / 2 - svgRect.left, y: indRect.bottom - svgRect.top };
                const to = { x: infoRect.left + infoRect.width / 2 - svgRect.left, y: infoRect.top - svgRect.top };
                const connection = {
                    from: { ...from, areaIndex, prodIndex, colKey, indicatorIndex },
                    to: { ...to, areaIndex, prodIndex, colKey, indicatorIndex },
                    color: "#000",
                    thickness: 2,
                    noArrow: true,
                    isInfo: true,
                };
                const existingIndex = this.areas[areaIndex].connections.findIndex(
                    (conn) =>
                        conn.isInfo &&
                        conn.from.areaIndex === areaIndex &&
                        conn.from.prodIndex === prodIndex &&
                        conn.from.colKey === colKey &&
                        conn.from.indicatorIndex === indicatorIndex
                );
                if (existingIndex !== -1) {
                    this.$set(this.areas[areaIndex].connections, existingIndex, connection);
                } else {
                    this.areas[areaIndex].connections.push(connection);
                }
            });
        },

        handleRemoveIndicator(areaIndex, prodIndex, colKey, indicatorIndex) {
            this.areas[areaIndex].connections = this.areas[areaIndex].connections.filter(
                (conn) =>
                    !(
                        (conn.from.areaIndex === areaIndex &&
                            conn.from.prodIndex === prodIndex &&
                            conn.from.colKey === colKey &&
                            conn.from.indicatorIndex === indicatorIndex) ||
                        (conn.to.areaIndex === areaIndex &&
                            conn.to.prodIndex === prodIndex &&
                            conn.to.colKey === colKey &&
                            conn.to.indicatorIndex === indicatorIndex)
                    )
            );

            this.areas[areaIndex].produtos[prodIndex][colKey].splice(indicatorIndex, 1);

            this.areas[areaIndex].connections.forEach(conn => {
                if (conn.from.areaIndex === areaIndex &&
                    conn.from.prodIndex === prodIndex &&
                    conn.from.colKey === colKey &&
                    conn.from.indicatorIndex > indicatorIndex) {
                    conn.from.indicatorIndex--;
                }
                if (conn.to.areaIndex === areaIndex &&
                    conn.to.prodIndex === prodIndex &&
                    conn.to.colKey === colKey &&
                    conn.to.indicatorIndex > indicatorIndex) {
                    conn.to.indicatorIndex--;
                }
            });

            this.$nextTick(() => {
                this.updateConnections();
            });
        },

        removeIndicator(areaIndex, prodIndex, colKey, indicatorIndex) {
            this.areas[areaIndex].produtos[prodIndex][colKey].splice(indicatorIndex, 1);
        },

        getLocalPgdiIndicator() {
            if (!this.modalContext || this.modalContext.areaIndex === null) return {};
            const { areaIndex, prodIndex, colKey, indicatorIndex } = this.modalContext;
            return (
                this.areas?.[areaIndex]?.produtos?.[prodIndex]?.[colKey]?.[indicatorIndex] || {}
            );
        },

        toggleEditInfo(indicator) {
            this.onFullScreenChange();
            this.$set(indicator, "tempInfo", {
                LastCropReal: indicator.LastCropReal ?? indicator.infos[0]?.LastCropReal ?? null,
                CropTarget: indicator.CropTarget ?? indicator.infos[0]?.CropTarget ?? null,
                ChronicTrigger: indicator.ChronicTrigger ?? indicator.infos[0]?.ChronicTrigger ?? null,
                CriticalTrigger: indicator.CriticalTrigger ?? indicator.infos[0]?.CriticalTrigger ?? null,
                ShowChronicTrigger: indicator.ShowChronicTrigger ?? indicator.infos[0]?.ShowChronicTrigger ?? false,
                ShowCriticalTrigger: indicator.ShowCriticalTrigger ?? indicator.infos[0]?.ShowCriticalTrigger ?? false,
            });

            this.$set(indicator, "editingInfo", true);
            this.setupInfoWatchers(indicator);
        },

        saveInfoEdit(indicator) {
            const temp = indicator.tempInfo;

            indicator.infos[0] = { ...temp };

            indicator.LastCropReal = temp.LastCropReal;
            indicator.CropTarget = temp.CropTarget;
            indicator.ChronicTrigger = temp.ChronicTrigger;
            indicator.CriticalTrigger = temp.CriticalTrigger;
            indicator.ShowChronicTrigger = temp.ShowChronicTrigger;
            indicator.ShowCriticalTrigger = temp.ShowCriticalTrigger;

            indicator.editingInfo = false;
            this.onFullScreenChange();
        },

        cancelInfoEdit(indicator) {
            delete indicator.tempInfo;
            delete indicator.tempShowChronicTrigger;
            delete indicator.tempShowCriticalTrigger;

            indicator.editingInfo = false;
            this.onFullScreenChange();
        },

        openModalOccurrences(indicator) {
            this.indicatorSelected = indicator;
            this.$bvModal.show("UntratedOccurrences");
        },

        openModalRTA(indicator) {
            this.$router.push({ name: 'rtalist', params: { indicatorId: indicator.Id } });
        },

        addIndicator(areaIndex, prodIndex, colKey) {
            const indicators = this.areas[areaIndex].produtos[prodIndex][colKey];

            if (indicators.some((ind) => !ind.Id || ind.Id === 0)) {
                this.openToast("Não é permitido adicionar indicador vazio.", "Atenção", "warning");
                return;
            }

            const newIndicator = {
                Id: 0,
                Value: 0,
                LowerLimit: 0,
                UpperLimit: 0,
                LastCropReal: 0,
                CropTarget: 0,
                ChronicTrigger: "",
                CriticalTrigger: "",
                Occurrences: 0,
                RTAs: 0
            };

            this.areas[areaIndex].produtos[prodIndex][colKey].push(newIndicator);
        },

        computedCardClasses(indicator) {
            let colorUsed = 3;
            if (indicator.OutOfRange) colorUsed = 2;
            return {
                alertBackground: colorUsed === 2,
                normalBackground: colorUsed === 3,
                neutralBackground: colorUsed === 4,
                "occurrence-alert": indicator.Occurrences > 0 || indicator.RTAs > 0,
            };
        },

        parseNumber(val) {
            if (val == null || val === "" || val === "-9999" || val === -9999) return "-";
            if (!isNaN(val)) return parseFloat(val).toFixed(2).replace(".", ",");
            return val;
        },

        openGridConfigModal(colKey) {
            this.gridModalKey = colKey;
            this.gridModalData = Object.assign({}, this.columnSettings[colKey]);
            this.$refs.gridConfigModal.show();
        },

        saveGridConfigModal() {
            this.$set(this.columnSettings, this.gridModalKey, Object.assign({}, this.gridModalData));
            this.$refs.gridConfigModal.hide();
        },
        cancelGridConfigModal() {
            this.$refs.gridConfigModal.hide();
        },
        openArrowColorModal() {
            if (!this.isEditMode) return;
            this.$refs.arrowColorModal.show();
        },
        cancelArrowColorModal() {
            this.$refs.arrowColorModal.hide();
        },
        saveArrowColorModal() {
            this.connectionConfig.color = this.arrowColorSelected;
            this.areas[this.activeAreaIndex].connections.forEach((conn) => {
                if (!conn.noArrow) {
                    conn.color = this.arrowColorSelected;
                }
            });
            this.$refs.arrowColorModal.hide();
        },
        cancelTextModal() {
            this.$refs.textModal.hide();
        },
        confirmTextModal() {
            this.$refs.textModal.hide();
        },
        toggleAreaSelection(index) {
            const areaId = this.areas[index].id;
            if (this.rotationSelectedAreas.includes(areaId)) {
                this.rotationSelectedAreas = this.rotationSelectedAreas.filter((id) => id !== areaId);
            } else {
                this.rotationSelectedAreas.push(areaId);
            }
        },
        onFullScreenChange() {
            setTimeout(() => {
                this.updateConnections();
            }, 10);
        },
        truncateText(text, maxLength) {
            if (!text) return '';
            if (text.length <= maxLength) return text;
            return text.substring(0, maxLength) + '...';
        },
        openToast(msg, title, variant) {
            this.$bvToast.toast(msg, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-bottom-left',
                solid: true
            })
        },
    },

    async mounted() {
        await this.loadRotationInfo();
        await this.loadPgdiIndicatorCards();
        await this.loadConfiguration();
        await this.updateIndicatorValues(true);
        this.indicatorTimer = setInterval(async () => {
            await this.updateIndicatorValues(false);
        }, 60000);
        this.$store.commit("setInfoReport", { show: true });
        this.$store.commit("setMsg", null);
        this.isLoading = false;
        window.addEventListener("keydown", this.onKeyDown);
        window.addEventListener("resize", this.updateConnections);
        window.addEventListener("fullscreenchange", this.onFullScreenChange);
        this.onFullScreenChange();
    },

    beforeDestroy() {
        this.stopAreaRotation();
        window.removeEventListener("keydown", this.onKeyDown);
        window.removeEventListener("resize", this.updateConnections);
        window.removeEventListener("fullscreenchange", this.onFullScreenChange);
        this.$store.commit("setDt1", null);
        this.$store.commit("setDt2", null);
        this.$store.commit("setInfoReport", { show: false });
        this.$store.commit("setMsg", " ");
        if (this.indicatorTimer) {
            clearInterval(this.indicatorTimer);
            this.indicatorTimer = null;
        }
    },
};
</script>

<style scoped>
.arvore-de-influencia {
    font-family: Arial, sans-serif;
    margin: 1rem;
    position: relative;
}

.tabs {
    margin-bottom: 1rem;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.tabs-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
}

.tab-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    height: 3rem;
    max-height: 3rem;
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap;
    scrollbar-width: thin;
    -ms-overflow-style: none;
    flex: 1;
}

.tab-list::-webkit-scrollbar {
    height: 6px;
}

.tab-list::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 3px;
}

.tab-list::-webkit-scrollbar-track {
    background-color: #f0f0f0;
}

.tab-item-sec {
    padding: 0.5rem 2rem;
    cursor: pointer;
    border-right: 1px solid #ccc;
    display: flex;
    align-items: center;
    background-color: transparent;
    transition: background-color 0.3s;
    flex: 0 0 auto;
    white-space: nowrap;
}

.tab-item {
    padding: 0.5rem 1rem;
    cursor: pointer;
    border-right: 1px solid #ccc;
    display: flex;
    align-items: center;
    background-color: transparent;
    transition: background-color 0.3s;
    flex: 0 0 auto;
    white-space: nowrap;
}

.tab-item.active,
.tab-item-sec.active {
    background-color: #f0f0f0;
    color: #333;
    font-weight: bold;
}

.btn-add-area,
.btn-icon,
.btn-edit-mode,
.btn-update-indicators {
    background: transparent;
    border: none;
    cursor: pointer;
}

.btn-edit-mode {
    cursor: default !important;
}

.btn-group-config {
    display: flex;
    align-items: center;
    margin-right: 0.5rem;
    flex: 0 0 auto;
}

.btn-group .b-button {
    min-width: 120px;
    text-align: center;
}

.btn-rotation-config {
    width: 22px;
    height: 22px;
    margin-right: 4px;
    margin-top: 2px;
}

.tab-item-title,
.tab-item-title-sec {
    margin-right: 0.5rem;
    font-weight: bold;
}

.produto-container {
    background-color: #f0f0f0;
    border: 1px solid #ddd;
    margin-bottom: 1rem;
    padding: 1rem;
    border-radius: 4px;
}

.produto-header {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: space-between;
    height: 1rem;
}

.btn-edit-product-name {
    background: transparent;
    border: none;
    font-size: 1rem;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    margin-right: 0.2rem;
}

.indicadores-grid {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;
}

.indicador-coluna {
    flex: 1;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
}

.col-header {
    padding: 0.5rem;
    color: #fff;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.btn-config {
    background: transparent;
    border: none;
    color: #fff;
    font-size: 1rem;
    margin-top: 4px;
    cursor: pointer;
}

.title-grid {
    font-size: 1.7rem;
    font-weight: 500;
    line-height: 1.2;
}

.cards-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3.5rem;
    padding: 0.5rem;
}

.indicador-card {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 260px;
    height: 70px;
    border-radius: 4px;
    box-shadow: -2px 0 3px rgba(0, 0, 0, 0.5);
    cursor: pointer;
}

.card-body {
    width: 100%;
    height: 100%;
    padding: 4px;
    box-sizing: border-box;
}

.row1 {
    font-size: 0.7em;
    color: white;
    margin: 2px 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.row2 {
    display: grid;
    grid-template-columns: 70px 1fr 70px;
    text-align: center;
    align-items: center;
    font-size: 0.8em;
    font-weight: bold;
    color: white;
}

.row2Col1,
.row2Col3 {
    font-size: 0.8em;
    font-weight: 400;
}

.row2Col2 {
    font-size: 1em;
}

.btn-remove {
    position: absolute;
    top: 2px;
    right: 2px;
    background: transparent;
    border: none;
    color: #fff;
    font-size: 1rem;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.3s;
}

.indicador-card:hover .btn-remove {
    opacity: 1;
}

.btn-add-indicator {
    background: transparent;
    border: none;
    color: #000;
    font-size: 1rem;
    margin: 0.5rem;
    cursor: pointer;
}

.count-occurrence-1,
.count-rta-1 {
    position: absolute;
    background-color: white;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    top: -5px;
}

.count-occurrence-2,
.count-rta-2 {
    position: absolute;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    top: 2.2px;
}

.count-occurrence-1 {
    right: -3px;
    cursor: pointer;
}

.count-occurrence-2 {
    background-color: #FF891B;
    right: 1.2px;
}

.count-rta-1 {
    right: 30px;
    cursor: pointer;
    border-radius: 20% !important;
}

.count-rta-2 {
    background-color: #009a9b;
    width: 24px;
    height: 24px;
    top: 2px;
    right: 2px;
    border-radius: 20% !important;
}

.has-rta-not-fcas {
    right: -3px !important;
}

.count-occurrence-text,
.count-occurrence-text-1,
.count-rta-text,
.count-rta-text-1 {
    color: black;
    font-weight: bolder;
    text-align: center;
    padding-top: 3px;
    font-size: 0.75rem;

}

.count-rta-text,
.count-rta-text-1 {
    color: white;
    padding-right: 1px;
}

.add-product-wrapper {
    margin-top: 1rem;
    text-align: right;
}

.btn-edit-mode {
    background: transparent;
    border: none;
    font-size: 1.2rem;
    margin: 0;
    padding: 0.5rem;
}

.btn-add-product {
    background: transparent;
    border: none;
    font-size: 1.2rem;
    cursor: pointer;
    padding: 0.3rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.btn-add-info {
    position: absolute;
    bottom: 4px;
    right: 4px;
    background: transparent;
    border: none;
    font-size: 1rem;
    cursor: pointer;
    color: #fff;
}

.connections-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 999;
}

.selected-line {
    stroke: #d11e1d !important;
    stroke-dasharray: 4;
}

.alertBackground {
    background-color: #d11e1d;
    color: #fff;
}

.normalBackground {
    background-color: #000;
    color: #fff;
}

.neutralBackground {
    background-color: #666666;
    color: #fff;
}

.occurrence-alert {
    box-shadow: 0 0 3px #FF891B;
}

.target-highlight {
    outline: 3px solid #FFF !important;
    transition: outline 0.3s ease;
}

.info-wrapper {
    position: relative;
    margin-top: 2rem;
    text-align: center;
}

.info-card {
    background-color: #f9f9f9;
    border: 1px solid #ccc;
    padding: 0.5rem 10px;
    border-radius: 4px;
    width: 260px;
    margin: 0 auto;
    font-size: 0.9em;
    text-align: justify;
}

.info-indicators-list {
    margin-top: 1rem;
}

.info-indicator-box {
    border: 1px solid #ccc;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
    border-radius: 4px;
}

.btn-edit-info {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 1rem;
    color: #333;
    position: absolute;
    right: 3px;
    top: 2px;
}

.btn-edit-info-disabled {
    background: transparent;
    position: absolute;
    right: 0;
    top: 0;
}

.btn-group-info {
    display: flex;
    justify-content: flex-end;
    width: 100%;
}

.btn-save-info,
.btn-cancel-info {
    background-color: #4CAF50;
    border: none;
    color: white;
    padding: 0.3rem 0.6rem;
    margin-right: 0.5rem;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9em;
}

.btn-cancel-info {
    background-color: #f44336;
}

.disableBtn {
    opacity: 0;
    cursor: none;
    pointer-events: none;
}

.disable-config,
.disable-remove {
    padding: 0;
}

.disable-indicator {
    margin: 0.5rem;
}

.disable-remove {
    border: none;
    margin-left: 0.2rem;
    background: transparent;
    font-size: 1rem;
}

.color-radio-group {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;
}

.color-option {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border-radius: 8px;
    cursor: pointer;
    color: #fff;
    font-weight: 500;
    transition: transform 0.2s, box-shadow 0.2s;
}

.color-option input[type="radio"] {
    margin-right: 8px;
}

.color-option:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}

.color-option.selected {
    border: 2px solid #009a9b;
    box-shadow: none;
}

.action-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    color: #ff751b;
}

.img-btn {
    width: 25px;
    height: 25px;
}

.img-btn-small {
    width: 20px;
    height: 20px;
}

.trash-img {
    margin-bottom: 1px;
}

.exit-btn {
    margin-left: 14px;
    margin-right: 7px;
}

.exit-btn-withoutmr {
    margin-left: 14px;
    margin-right: 0px;
}

.btn-add-ind {
    margin-bottom: 5px;
    margin-left: 2px;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.loading-over {
    width: 60px;
    height: 60px;
    margin-bottom: 200px;
}

.p-firstitem {
    margin-top: 10px;
}

.no-config {
    margin: 20px;
    font-size: 18px;
    text-align: center;
}

.iconPermission {
    position: absolute;
    width: 400px;
    top: calc(45% - -5rem);
    left: calc(45% - 7rem);
    opacity: 0.1;
}

.clockText {
    position: absolute;
    top: 18rem;
    text-align: center;
    width: 100%;
    font-size: 1.5rem;
}

.img-btn-refresh {
    width: 26px;
    height: 27px;
    margin-top: 1px;
}

.rotation-areas-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    max-height: 200px;
    overflow-y: auto;
    padding: 8px;
}

.rotation-area-button {
    flex: 0 1 auto;
    min-width: fit-content;
    white-space: nowrap;
    margin: 0 !important;
}
</style>